export const environment = {
  production: true,
  CommonBaseHref: '',
  CompayName: "JMF",
  CompanyId: 1,
  environmentDigio: "sandbox",

  // URL: "https://invest.iiflsecurities.com/",
  // ServerUrl: 'https://investapi.iiflsecurities.com/',
  // RazorPayCallBackURL: "https://investapi.iiflsecurities.com/api/RazorPayWebhook/GetWebhookStatus",
  
  // URL: "http://10.33.2.45:8081/",
  // ServerUrl: 'http://10.33.2.45:8081/',
  //   ServerUrlIIFLEsign:'http://10.33.2.45:8081/',
  // RazorPayCallBackURL: "http://10.33.2.45:8081/api/RazorPayWebhook/GetWebhookStatus",
  // ServerUrlIIFL: 'http://10.33.2.45:8081/',
  
  
    URL: "https://uatwrapper.incredmarkets.com",
  ServerUrl: 'https://uatwrapper.incredmarkets.com',
    ServerUrlIIFLEsign:'https://uatwrapper.incredmarkets.com',
  RazorPayCallBackURL: "https://uatwrapper.incredmarkets.comapi/RazorPayWebhook/GetWebhookStatus",
  ServerUrlIIFL: 'https://uatwrapper.incredmarkets.com', 
  RazorPayKey: "rzp_live_BJvtaZZKvSHxkw",
  ICCLAccount: 'MFDICC000179',
  Version:"0.0.0.1",
  //Added by Tishya for POA EDIS start here
  BusinessID_POAEDIS: "1",
  GenerateTPIN_URL: "https://edis.cdslindia.com/home/generatePin",
  VerifyDIS_URL: "https://edis.cdslindia.com/EDIS/VerifyDIS",
  //Added by Tishya for POA EDIS end here
     BrandGuideCompayName : "Incred",
  androidCleverTapVariable: "",
  IOSCleverTapVariable: "",
  Password : "0Nn9XwxtBNtYX5r+wM0D7g==",
//GoogleclientId : "990783543147-9hntmhsvoee5gnk9d9avb8taa762egju.apps.googleusercontent.com",
GoogleclientId : "990783543147-jenc82d8cb49m384d5tairu5km5fvc09.apps.googleusercontent.com",
  //RSA_PUBLIC_KEY_BASE64: "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApOuWVdQ7goOb8xeaE40GubE4YOx82ejtuSu0wMPMG9bUU9wF83wSM/Xm3CMF3FTbSYwiDVkDQTB5P0Y5MOxEA9ceSKmZRHwEdN32BpVekroH0xOJQkzNpLQ39qPT1V/ifDzMbQEnsIV0AQPjVxnJMzKKQ+Yf4xrs0jqVhvEAC3fWU0vDIWefGUL76K7QIc0wiX5lNpzgZj3LgX8+x/K+DKEoB20pD2FugS+VL7uKuZ0jc/tp4Fgyd79OYME1DGmUmTCUfW4nNCRien34HeAfRjbYGF4v89xq9LZiEM6TzNiNDk9+45uVOw62Ebm/mRH/WdwP3fvds30ThVqqlyZQcQIDAQAB"
  RSA_PUBLIC_KEY_BASE64:"MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApOuWVdQ7goOb8xeaE40GubE4YOx82ejtuSu0wMPMG9bUU9wF83wSM/Xm3CMF3FTbSYwiDVkDQTB5P0Y5MOxEA9ceSKmZRHwEdN32BpVekroH0xOJQkzNpLQ39qPT1V/ifDzMbQEnsIV0AQPjVxnJMzKKQ+Yf4xrs0jqVhvEAC3fWU0vDIWefGUL76K7QIc0wiX5lNpzgZj3LgX8+x/K+DKEoB20pD2FugS+VL7uKuZ0jc/tp4Fgyd79OYME1DGmUmTCUfW4nNCRien34HeAfRjbYGF4v89xq9LZiEM6TzNiNDk9+45uVOw62Ebm/mRH/WdwP3fvds30ThVqqlyZQcQIDAQAB",
 

};



